import fontFamilies from './fontFamilies';
// @TODO Style should depends on the font
// https://stackoverflow.com/questions/56949513/typescript-type-of-a-property-dependent-on-another-property-within-the-same-obj
export interface TextStyle {
    fontFamily: string;
    fontStyle?: string;
    fontSize: string;
    fontWeight: string;
    letterSpacing?: string;
    lineHeight: string;
    textDecoration?: string;
    textTransform?: string;
    textIndent?: string;
}

export type Typography = keyof typeof typography;
const typography: Record<string, TextStyle> = {
    TypographyExample: {
        fontFamily: 'comic sans ms',
        fontSize: '80px',
        lineHeight: '120%',
        letterSpacing: '0%',
        fontWeight: '500',
        textTransform: 'none',
    },
    'Primary/40_100_510_-5': {
        fontFamily: fontFamilies.primary,
        fontSize: '40px',
        lineHeight: '100%',
        letterSpacing: '-5%',
        fontWeight: '510',
    },

    'Primary/30_100_510_-5': {
        fontFamily: fontFamilies.primary,
        fontSize: '30px',
        lineHeight: '100%',
        letterSpacing: '-5%',
        fontWeight: '510',
    },

    'Primary/24_110_510_-3': {
        fontFamily: fontFamilies.primary,
        fontSize: '24px',
        lineHeight: '110%',
        letterSpacing: '-3%',
        fontWeight: '510',
    },

    'Primary/20_120_510_-3': {
        fontFamily: fontFamilies.primary,
        fontSize: '20px',
        lineHeight: '120%',
        letterSpacing: '-3%',
        fontWeight: '510',
    },

    'Primary/15_120_510_-1': {
        fontFamily: fontFamilies.primary,
        fontSize: '15px',
        lineHeight: '120%',
        letterSpacing: '-1%',
        fontWeight: '510',
    },

    'Primary/15_120_510_-1_Indent': {
        textIndent: '30px',
        fontFamily: fontFamilies.primary,
        fontSize: '15px',
        lineHeight: '120%',
        letterSpacing: '-1%',
        fontWeight: '510',
    },

    'Primary/12_120_510_-1': {
        fontFamily: fontFamilies.primary,
        fontSize: '12px',
        lineHeight: '120%',
        letterSpacing: '-1%',
        fontWeight: '510',
    },

    'Primary/Mobile/18_120_510_-3': {
        fontFamily: fontFamilies.primary,
        fontSize: '18px',
        lineHeight: '120%',
        letterSpacing: '-3%',
        fontWeight: '510',
    },

    'Primary/Mobile/13_100_510_-1': {
        fontFamily: fontFamilies.primary,
        fontSize: '13px',
        lineHeight: '100%',
        letterSpacing: '-1%',
        fontWeight: '510',
    },

    'Primary/Mobile/13_100_510_-1__Indent': {
        textIndent: '30px',
        fontFamily: fontFamilies.primary,
        fontSize: '13px',
        lineHeight: '120%',
        letterSpacing: '-1%',
        fontWeight: '510',
    },

    'Primary/Mobile/11_100_510_-1': {
        fontFamily: fontFamilies.primary,
        fontSize: '11px',
        lineHeight: '120%',
        letterSpacing: '-1%',
        fontWeight: '510',
    },

    'Secondary/24_120_400_-1': {
        fontFamily: fontFamilies.secondary,
        fontSize: '24px',
        lineHeight: '120%',
        letterSpacing: '-1%',
        fontWeight: '400',
    },

    'Secondary/24_120_400_-1_Indent': {
        textIndent: '30px',
        fontFamily: fontFamilies.secondary,
        fontSize: '24px',
        lineHeight: '120%',
        letterSpacing: '-1%',
        fontWeight: '400',
    },

    'Secondary/20_120_400_-1_Indent': {
        textIndent: '30px',
        fontFamily: fontFamilies.secondary,
        fontSize: '20px',
        lineHeight: '120%',
        letterSpacing: '-1%',
        fontWeight: '400',
    },

    'Secondary/20_120_400_-1': {
        fontFamily: fontFamilies.secondary,
        fontSize: '20px',
        lineHeight: '120%',
        letterSpacing: '-1%',
        fontWeight: '400',
    },

    'Secondary/15_120_400_Indent': {
        textIndent: '30px',
        fontFamily: fontFamilies.secondary,
        fontSize: '15px',
        lineHeight: '120%',
        letterSpacing: '0%',
        fontWeight: '400',
    },

    'Secondary/15_120_400': {
        fontFamily: fontFamilies.secondary,
        fontSize: '15px',
        lineHeight: '120%',
        letterSpacing: '0%',
        fontWeight: '400',
    },

    'Secondary/Mobile/18_120_400_-1_Indent': {
        textIndent: '30px',
        fontFamily: fontFamilies.secondary,
        fontSize: '18px',
        lineHeight: '120%',
        letterSpacing: '-1%',
        fontWeight: '400',
    },

    'Secondary/Mobile/18_120_400_-1': {
        fontFamily: fontFamilies.secondary,
        fontSize: '18px',
        lineHeight: '120%',
        letterSpacing: '-1%',
        fontWeight: '400',
    },

    'Secondary/Mobile/13_120_400_Indent': {
        textIndent: '30px',
        fontFamily: fontFamilies.secondary,
        fontSize: '13px',
        lineHeight: '120%',
        letterSpacing: '0%',
        fontWeight: '400',
    },

    'Secondary/Mobile/13_120_400': {
        fontFamily: fontFamilies.secondary,
        fontSize: '13px',
        lineHeight: '120%',
        letterSpacing: '0%',
        fontWeight: '400',
    },

    'Secondary/misc-15_120_400_-1': {
        fontFamily: fontFamilies.primary,
        fontSize: '15px',
        lineHeight: '120%',
        letterSpacing: '-1%',
        fontWeight: '400',
    },

    'Secondary/misc-13_120_400_-1': {
        fontFamily: fontFamilies.primary,
        fontSize: '13px',
        lineHeight: '120%',
        letterSpacing: '-1%',
        fontWeight: '400',
    },
};

export default typography;
